// @flow
import React from 'react'
// $FlowFixMe
import Select from 'react-select'
import { FormField, StyledField, Label, Error } from 'src/components/Form'
import type { DateField as DateFieldProps } from 'src/types'

const customStyles = {
  container: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    margin: '7px 0',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    borderColor: 'none'
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: '#082622'
  }),
  control: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    fontSize: '16px',
    fontFamily: "'RelativeBook', 'Helvetica', 'Arial', sans-serif",
    outline: 'none',
    backgroundColor: 'none',
    padding: '0 10px',
    border: 'none',
    boxShadow: 'none'
  }),
  placeholder: (base, state) => ({
    ...base,
    color: '#6e7b8c'
  }),
  singleValue: (base, state) => ({
    ...base,
    color: '#082622'
  }),
  indicatorSeparator: (base, state) => ({
    color: '#fff'
  }),
  menu: (base, state) => ({
    ...base,
    marginTop: '15px'
  }),
  option: (base, state) => ({
    ...base,
    color: '#082622',
    height: '100%',
    marginTop: '5px',
    marginBottom: '5px',
    backgroundColor: '#fff',
    backgroundImage: state.isSelected ? 'linear-gradient(#f8f9fa, #f8f9fa)' : 'none'
  })
}

const renderSelect = ({
  className,
  input,
  label,
  type,
  options,
  components,
  isInitPage,
  required,
  meta: { touched, error }
}: DateFieldProps) => (
  <FormField
    className={className}
    isInitPage={isInitPage}
    hasError={isInitPage && touched && error}
  >
    <Label>{label}</Label>
    <StyledField isInitPage={isInitPage} hasError={touched && error}>
      <Select
        {...input}
        styles={customStyles}
        value={input.value}
        onChange={value => input.onChange(value)}
        onBlur={() => input.onBlur(undefined)}
        options={options}
        components={components}
        placeholder={'Please select...'}
        backspaceRemovesValue={false}
      />
      {touched && error && (
        <Error>Oh, you need to select {`${label}`.toLowerCase()} to continue</Error>
      )}
    </StyledField>
  </FormField>
)

export default renderSelect



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/Select.js